export enum MeasurementTypes {
  Volume = 1,
  CostPerUnit = 2,
  FuelEconomy = 3,
  FuelConsumption = 4,
  Percentage = 5,
  Hours = 6
}